export class Application {
    id: string;
    applicationName: string;
    hideApplication: boolean;

    constructor()
    {
        this.id="";
        this.applicationName="";
        this.hideApplication=false;
    }
}